import React from 'react'
import RegisteredStudentsInfo from "../../components/Olympiad/RegisteredStudentsMain/ViewMain/RegisteredStudentsViewDetails"
const RegisteredStudentsDetails = () => {
  return (
    <div><RegisteredStudentsInfo/></div>
  )
}

export default RegisteredStudentsDetails